/**
 * Título del libro «Resumen Impuestos : [cliente]».
 * Si el nombre es corto se muestra completo; si es largo, primeras dos palabras.
 */
export function formatTaxSummaryWorkbookTitle(clientName, { maxFullLength = 36 } = {}) {
  const raw = String(clientName || "").trim();
  if (!raw) return "Resumen Impuestos";
  if (raw.length <= maxFullLength) {
    return `Resumen Impuestos : ${raw}`;
  }
  const words = raw.split(/\s+/).filter(Boolean);
  if (words.length <= 2) {
    return `Resumen Impuestos : ${raw}`;
  }
  const short = `${words[0]} ${words[1]}`;
  return `Resumen Impuestos : ${short}`;
}

export function yearFromPeriodKey(periodKey) {
  const match = String(periodKey || "").match(/^(\d{4})/);
  return match ? Number(match[1]) : new Date().getFullYear();
}
